import React from "react";
import { Tooltip } from "antd";

import UraIcon from "../assets/images/ura.png";
import OniIcon from "../assets/images/oni.png";
import HardIcon from "../assets/images/hard.png";
import NormalIcon from "../assets/images/normal.png";
import EasyIcon from "../assets/images/easy.png";

const DifficultyTag = ({ difficulty }) => {
    const difficultyStyles = {
        width: "25x",
        height: "25px",
    };

    const renderDifficulty = (difficulty) => {
        switch (difficulty) {
            case 1:
                return (
                    <Tooltip title="Easy">
                        <img src={EasyIcon} style={difficultyStyles} alt="" />
                    </Tooltip>
                );
            case 2:
                return (
                    <Tooltip title="Normal">
                        <img src={NormalIcon} style={difficultyStyles} alt="" />
                    </Tooltip>
                );
            case 3:
                return (
                    <Tooltip title="Hard">
                        <img src={HardIcon} style={difficultyStyles} alt="" />
                    </Tooltip>
                );
            case 4:
                return (
                    <Tooltip title="Oni">
                        <img src={OniIcon} style={difficultyStyles} alt="" />
                    </Tooltip>
                );
            case 5:
                return (
                    <Tooltip title="Ura">
                        <img src={UraIcon} style={difficultyStyles} alt="" />
                    </Tooltip>
                );
            default:
                return null;
        }
    };

    return renderDifficulty(difficulty);
};

export default DifficultyTag;
